<template>
    <m-layout>
      <div fill-height class="fill-height" style="width:100%">

        <m-booqit></m-booqit>

      </div>
    </m-layout>
</template>

<script>
  import Booqit from '@/components/booqit/transports'
  export default {
    name: 'booqit',
    components: {
      'm-booqit': Booqit
    },
    data () {
      return {}
    },
    methods: {},
    watch: {},
    created () {},
    mounted () {},
    beforeDestroy () {}
  }
  </script>
<style lang="scss">
</style>
